import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Subheader from "material-ui/Subheader";
import { List, ListItem, makeSelectable } from "material-ui/List";

import MyFinance from "./my-finance";
import CompanyIntegrationsSat from "./sat";
import Napp from "./napp";
import Webhooks from "./webhooks";
import Tray from "./tray";
import MercadoPago from "./mercado-pago";
import OrderIntegrations from "./order_integrations";
import Oms from "./oms";

import styles from "./styles";

const SelectableList = makeSelectable(List);

export default class CompanyIntegrations extends Component {
  static integrationsTree = [
    {
      label: "MyFinance",
      component: MyFinance,
      isCompanyAllowed: () => true
    },
    {
      label: "Webhooks",
      component: Webhooks,
      isCompanyAllowed: () => true
    },
    {
      label: "SAT",
      component: CompanyIntegrationsSat,
      isCompanyAllowed: company => company.address.state === "SP"
    },
    {
      label: "Napp",
      component: Napp,
      isCompanyAllowed: () => true
    },
    {
      label: "Tray",
      component: Tray,
      isCompanyAllowed: () => true
    },
    {
      label: "Mercado Pago",
      component: MercadoPago,
      isCompanyAllowed: () => true
    },
    {
      label: "Pedidos Externos",
      component: OrderIntegrations,
      isCompanyAllowed: () => true
    },
    {
      label: "Nexaas OMS",
      component: Oms,
      isCompanyAllowed: () => true
    }
  ];

  constructor(props) {
    super(props);

    this.state = {
      integration: {
        label: "",
        component: null
      }
    };
  }

  currentComponent = () => {
    if (this.state.integration.component) {
      return <this.state.integration.component company={this.props.company} />;
    }
  };

  handleIntegrationChange = (_, selected) => {
    const integration = CompanyIntegrations.integrationsTree.find(
      integration => integration.label === selected
    );
    this.setState({ integration });
  };

  integrationListItem = integration => {
    const disabled = !integration.isCompanyAllowed(this.props.company);

    return (
      <ListItem
        value={integration.label}
        key={integration.label}
        primaryText={integration.label}
        disabled={disabled}
        style={
          disabled ? styles.disabledIntegration : styles.enabledIntegration
        }
      />
    );
  };

  render() {
    return (
      <div className="grid-container">
        <Row>
          <Col lg={3} md={4} sm={5} xs={5} style={styles.integrationList}>
            <SelectableList
              value={this.state.integration.label}
              onChange={this.handleIntegrationChange}
            >
              <Subheader>Integrações</Subheader>
              {CompanyIntegrations.integrationsTree.map(
                this.integrationListItem
              )}
            </SelectableList>
          </Col>
          <Col lg={9} md={8} sm={7} xs={7}>
            {this.currentComponent()}
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/index.jsx